import React, { ReactNode } from 'react';

import styles from './template-title.scss';

interface TemplateTitleProps {
  icon: ReactNode;
  title: ReactNode;
}

export const TemplateTitle = ({ icon, title }: TemplateTitleProps) => {
  return (
    <div className={styles.templateTitle}>
      {icon}
      <h2 className="uiTypeHeader">{title}</h2>
    </div>
  );
};
